export default "__VITE_ASSET__B6H8t6co__"